let runtimeConfig: Record<string, string> = {};

try {
  const response = await fetch("/config.json");

  if (response.ok) {
    runtimeConfig = await response.json();
  }
} catch {
  runtimeConfig = {};
}

function readConfigValue(key: string): string | undefined {
  return runtimeConfig[key] || undefined;
}

export const tendraEnvironment =
  readConfigValue("TENDRA_ENVIRONMENT") ?? "Production";

const isDevelopment = tendraEnvironment === "Development";

const missingKeys: string[] = [];

function requireConfigValue(key: string, developmentFallback: string): string {
  const value = readConfigValue(key);

  if (value) {
    return value;
  }

  if (isDevelopment) {
    return developmentFallback;
  }

  missingKeys.push(`BUN_PUBLIC_${key}`);

  return "";
}

function optionalConfigValue(key: string): string {
  return readConfigValue(key) ?? "";
}

export const oidcConfig = {
  authority: requireConfigValue("OIDC_AUTHORITY", "https://localhost:5002"),
  clientId: requireConfigValue("OIDC_CLIENT_ID", "Tendra.App"),
  redirectUri: requireConfigValue(
    "OIDC_REDIRECT_URI",
    "http://localhost:5004/callback",
  ),
  postLogoutRedirectUri: requireConfigValue(
    "OIDC_POST_LOGOUT_REDIRECT_URI",
    "http://localhost:5004/",
  ),
  scope: "openid profile email offline_access",
};

export const apiUrl = requireConfigValue("API_URL", "https://localhost:5001");

export const sentryDsn = optionalConfigValue("SENTRY_DSN");

if (missingKeys.length > 0) {
  throw new Error(
    `Missing required configuration (${missingKeys.length}): ${missingKeys.join(", ")}`,
  );
}
